import { createFileRoute } from "@tanstack/react-router";
import { AdjustmentDetailPage } from "@/components/inventory/AdjustmentDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/adjustments_/$id")({
  component: AdjustmentDetailRoute,
});

function AdjustmentDetailRoute() {
  const { id } = Route.useParams();
  return <AdjustmentDetailPage adjustmentId={id} />;
}
